import * as QuickSelect from "./quick-select";

export class QuickSelectHarnessController {
  public advancedItems: QuickSelect.QuickSelectMenuItemCollection;
  public countries: QuickSelect.QuickSelectMenuItemCollection;
  public supportAreaPaths: QuickSelect.QuickSelectMenuItemCollection;

  constructor() {
    this.countries = this.toQuickSelectItem(this.countriesStrings);
    this.supportAreaPaths = this.toQuickSelectItem(this.supportAreaPathsStrings);
    this.supportAreaPaths[60].id = "quickselect-e2e";
    this.createAdvancedItems("Ctor -");
  }

  public createAdvancedItems(prefix: string) {
    let newAdvancedItems: QuickSelect.QuickSelectMenuItemCollection = [];
    for (let i = 0; i < 1000; i++) {
      let item: QuickSelect.QuickSelectItem & any = {
        displayName: `${prefix} advanced object ${i}`,
        value: i,
        country: this.countriesStrings[i],
        isSelected: i > 1 && i < 5
      };
      newAdvancedItems.push(item);
    }
    this.advancedItems = newAdvancedItems;
  }

  public selectEveryOtherElement(items: QuickSelect.QuickSelectMenuItemCollection) {
    items.forEach((item: QuickSelect.QuickSelectItem, index: number) => {
      if (index % 2 === 0) {
        item.isSelected = true;
      }
    });
    items.$sd.refresh();
  }

  public toQuickSelectItem(list: string[]): QuickSelect.QuickSelectItem[] {
    return list.map((s) => {
      return { displayName: s };
    });
  }

  public menuItemSelected(selection: QuickSelect.QuickSelection): string {
    return JSON.stringify(selection, undefined, 2);
  }

  public countriesStrings: string[] = [
    "European Union",
    "China",
    "United States",
    "Germany",
    "Japan",
    "South Korea",
    "France",
    "Hong Kong",
    "Netherlands",
    "Italy",
    "United Kingdom",
    "Canada",
    "Mexico",
    "Singapore",
    "United Arab Emirates",
    "Taiwan",
    "Switzerland",
    "India",
    "Spain",
    "Russia",
    "Belgium",
    "Saudi Arabia",
    "Thailand",
    "Brazil",
    "Poland",
    "Australia",
    "Malaysia",
    "Vietnam",
    "Turkey",
    "Sweden",
    "Indonesia",
    "Austria",
    "Czech Republic",
    "Ireland",
    "Norway",
    "Hungary",
    "Denmark",
    "South Africa",
    "Qatar",
    "Slovakia",
    "Puerto Rico",
    "Iran",
    "Chile",
    "Finland",
    "Argentina",
    "Romania",
    "Israel",
    "Kuwait",
    "Iraq",
    "Portugal",
    "Kazakhstan",
    "Nigeria",
    "Philippines",
    "Venezuela"
  ];

  public supportAreaPathsStrings: string[] = [
    "Azure\\Antimalware for Azure Cloud Services and Virtual Machines",
    "Azure\\Azure Active Directory",
    "Azure\\Azure Advisor",
    "Azure\\Azure Alert Service",
    "Azure\\Azure Analysis Services",
    "Azure\\Azure API Management Service",
    "Azure\\Azure App Service",
    "Azure\\Azure Application",
    "Azure\\Azure ASMS - Backup workflow",
    "Azure\\Azure Automation",
    "Azure\\Azure AutoScale Service",
    "Azure\\Azure Batch",
    "Azure\\Azure Billing",
    "Azure\\Azure BizTalk Services",
    "Azure\\Azure Bot Service",
    "Azure\\Azure Business Desk Support",
    "Azure\\Azure Cache Services",
    "Azure\\Azure CDN Akamai",
    "Azure\\Azure CDN Verizon",
    "Azure\\Azure Cloud Services",
    "Azure\\Azure Cognitive Services",
    "Azure\\Azure Container Service",
    "Azure\\Azure Data",
    "Azure\\Azure Datamarket",
    "Azure\\Azure DevTest Labs",
    "Azure\\Azure DNS",
    "Azure\\Azure DocumentDB",
    "Azure\\Azure EA",
    "Azure\\Azure Event Hubs",
    "Azure\\Azure ExpressRoute",
    "Azure\\Azure ExpressRoute Carrier Escalation to Engineering",
    "Azure\\Azure Functions",
    "Azure\\Azure GCC Business Desk",
    "Azure\\Azure HDInsight Service",
    "Azure\\Azure Information Protection",
    "Azure\\Azure IoT",
    "Azure\\Azure Key Vault",
    "Azure\\Azure Load Balancer",
    "Azure\\Azure Log Integration",
    "Azure\\Azure Machine Learning",
    "Azure\\Azure Management Portal",
    "Azure\\Azure Media Services",
    "Azure\\Azure Mobile Engagement",
    "Azure\\Azure Monitor",
    "Azure\\Azure Multi-Factor Authentication - PhoneFactor",
    "Azure\\Azure Network Watcher",
    "Azure\\Azure Notification Hub",
    "Azure\\Azure Portal Sign-in or Subscription",
    "Azure\\Azure Quota Changes",
    "Azure\\Azure Recovery Services",
    "Azure\\Azure Relay",
    "Azure\\Azure RemoteApp",
    "Azure\\Azure Scheduler",
    "Azure\\Azure Search",
    "Azure\\Azure Security Center",
    "Azure\\Azure Service",
    "Azure\\Azure sign-up process",
    "Azure\\Azure SQL",
    "Azure\\Azure Storage",
    "Azure\\Azure StorSimple",
    "Azure\\Azure Stream Analytics",
    "Azure\\Azure Subscription Management",
    "Azure\\Azure Support for Cloud Deutschland",
    "Azure\\Azure Traffic Manager Service",
    "Azure\\Azure Virtual",
    "Azure\\Azure Virtual Machine running",
    "Azure\\Azure VPN Gateway",
    "Azure\\Azure Web App",
    "Band\\Band",
    "Bing\\Bing",
    "Bing\\Bing Bar",
    "Bing\\Bing cashback",
    "Bing\\Bing local",
    "Bing\\Bing maps",
    "Bing\\Bing maps for enterprise",
    "Bing\\Bing Places for Business",
    "Browser\\Edge",
    "Browser\\Internet Explorer",
    "Camera\\LifeCam",
    "Camera\\LifeCam Studio",
    "Camera\\LifeChat LX-4000",
    "Cloud and Online Services\\21Vianet Azure",
    "Cloud and Online Services\\21Vianet MySQL Database Service on Azure",
    "Cloud and Online Services\\Cloud Platform System",
    "Cloud and Online Services\\Dynamics 365",
    "Cloud and Online Services\\GigJam",
    "Cloud and Online Services\\Marketplace Publisher",
    "Cloud and Online Services\\Micosoft Azure Container Registry",
    "Cloud and Online Services\\MSfC Azure-Azure Apps (IaaS)",
    "Cloud and Online Services\\MSfC Azure-Modern Apps",
    "Cloud and Online Services\\MSfC Azure-VM",
    "Cloud and Online Services\\MSfC CRM Online",
    "Cloud and Online Services\\MSfC Custom",
    "Cloud and Online Services\\MSfC Exchange",
    "Cloud and Online Services\\MSfC O365-Exchange Online",
    "Cloud and Online Services\\MSfC O365-Identity Mgmt Online",
    "Cloud and Online Services\\MSfC O365-Lync Online",
    "Cloud and Online Services\\MSfC O365-SharePoint Online",
    "Cloud and Online Services\\MSfC OneDrive",
    "Cloud and Online Services\\MSfC Yammer",
    "Cloud and Online Services\\Operations Management Suite",
    "Cloud and Online Services\\PowerApps",
    "Cloud and Online Services\\R Server",
    "Cloud and Online Services\\Revolution Analytics",
    "Cloud and Online Services\\Scout (InMage – 8.0)",
    "Cloud and Online Services\\StaffHub",
    "Cloud and Online Services\\Virtual Machine - Cloud Foundry",
    "Design Tools, Photos and Publishing\\Expression Blend",
    "Design Tools, Photos and Publishing\\Expression Design",
    "Design Tools, Photos and Publishing\\Expression Encoder",
    "Design Tools, Photos and Publishing\\Expression Studio",
    "Design Tools, Photos and Publishing\\Expression Web",
    "Design Tools, Photos and Publishing\\NOOK for Windows",
    "Developer Tools\\.NET Core 1.0",
    "Developer Tools\\.NET Framework",
    "Developer Tools\\.NET Micro Framework",
    "Developer Tools\\Agents for Visual Studio 2012",
    "Developer Tools\\AJAX Library",
    "Developer Tools\\AJAX Library 3.5",
    "Developer Tools\\Application Compatibility Toolkit 5.0",
    "Developer Tools\\ASP .NET",
    "Developer Tools\\ASP .NET 2.0 AJAX Extensions",
    "Developer Tools\\ASP .NET Core 1.0",
    "Developer Tools\\ASP .NET MVC 2.0",
    'Developer Tools\\Desktop Bridge ("Centennial")',
    "Developer Tools\\Device Emulator 2.0",
    "Developer Tools\\Entity Framework Core 1.0",
    "Developer Tools\\ESP",
    "Developer Tools\\ESP Software Developer Kit",
    "Developer Tools\\Flow",
    "Developer Tools\\Hardware Lab Kit for Windows 10",
    "Developer Tools\\Havok",
    "Developer Tools\\HockeyApp",
    "Developer Tools\\IntelliTrace Collector for Visual Studio",
    "Developer Tools\\jQuery with ASP .NET MVC 2",
    "Developer Tools\\Kinect for Windows Software Development",
    "Developer Tools\\Lync 2013 Software Development Kit",
    "Developer Tools\\Lync Server 2010 Conference Call Control Software Development Kit",
    "Developer Tools\\Lync Server 2013 Persistent Chat Software Development Kit",
    "Developer Tools\\Lync Server 2013 Software Development Kit",
    "Developer Tools\\Microsoft Deployment Agent 2013",
    "Developer Tools\\Office Communications Server 2007 Software Development Kit",
    "Developer Tools\\Online Services Interface",
    "Developer Tools\\Passport Network 3.0",
    "Developer Tools\\Platform Ready Test Tool 3.0",
    "Developer Tools\\PlayReady Server Software Development Kit v. 2.0",
    "Developer Tools\\ProClarity for Reporting Services 6.3",
    "Developer Tools\\ProClarity SharePoint Viewer 6.3",
    "Developer Tools\\ProClarity Software Development Kit 6.3",
    "Developer Tools\\Release Management",
    "Developer Tools\\Release Management for Visual Studio 2015",
    "Developer Tools\\SharePoint 2010 Administration Toolkit",
    "Developer Tools\\SharePoint Administration Toolkit",
    "Developer Tools\\Silverlight for Windows",
    "Developer Tools\\Subscription and Commerce Service",
    "Developer Tools\\Sync Framework",
    "Developer Tools\\Synchronization Services for ADO.NET 1.0 Service Pack 1",
    "Developer Tools\\System Center Updates Publisher 4.5",
    "Developer Tools\\Test Agent",
    "Developer Tools\\Test Controller",
    "Developer Tools\\TFS Migrator Preview",
    "Developer Tools\\Unified Communications AJAX Software Development Kit",
    "Developer Tools\\UPnP Certification Test Tool",
    "Developer Tools\\Visual J# Version 2.0 Redistributable Package Second Edition",
    "Developer Tools\\Visual SourceSafe 2005",
    "Developer Tools\\Visual Studio 2008",
    "Developer Tools\\Visual Studio 2008 Shell (integrated mode)",
    "Developer Tools\\Visual Studio 2010",
    "Developer Tools\\Visual Studio 2010 Remote Debugger",
    "Developer Tools\\Visual Studio 2012",
    "Developer Tools\\Visual Studio 2013",
    "Developer Tools\\Visual Studio 2015",
    "Developer Tools\\Visual Studio 2017",
    "Developer Tools\\Visual Studio 2017 RC Chat",
    "Developer Tools\\Visual Studio Code",
    "Developer Tools\\Visual Studio Express 2012",
    "Developer Tools\\Visual Studio Lab Management 2010",
    "Developer Tools\\Visual Studio LightSwitch 2011",
    "Developer Tools\\Visual Studio Professional 2012",
    "Developer Tools\\Visual Studio Team Agents 2010",
    "Developer Tools\\Visual Studio Test Professional",
    "Developer Tools\\Visual Web Developer 2010 Express",
    "Developer Tools\\WebMatrix",
    "Developer Tools\\Windows 10 Universal App Dev",
    "Developer Tools\\Windows 8.x Store App Dev",
    "Developer Tools\\Windows App Certification Kit",
    "Developer Tools\\Windows Communication Foundation",
    "Developer Tools\\Windows DevCenter app publishing",
    "Developer Tools\\Windows Driver Kit",
    "Developer Tools\\Windows Embedded Device Manager Software Development Kit",
    "Developer Tools\\Windows Hardware Certification Kit for Windows 8.1",
    "Developer Tools\\Windows Identity Foundation",
    "Developer Tools\\Windows Mobile Application Development",
    "Developer Tools\\Windows Phone SDK 8.0",
    "Developer Tools\\Windows Security Center Software Development Kit",
    "Developer Tools\\Windows Software Development Kit",
    "Developer Tools\\Winternals Administrator's Pak 4.2",
    "Developer Tools\\Winternals Protection Manager 1.0",
    "Developer Tools\\Winternals Recovery Manager 1.2",
    "Developer Tools\\Workflow Manager Tools for Visual Studio 2012",
    "Developer Tools\\Xamarin",
    "Health Solutions\\HealthVault",
    "Health Solutions\\HealthVault Connection Center",
    "Health Solutions\\HealthVault for Mobile",
    "HoloLens\\HoloLens",
    "Keyboard\\All-in-One Media Keyboard",
    "Keyboard\\Arc Keyboard",
    "Keyboard\\Bluetooth Mobile Keyboard 5000",
    "Keyboard\\Comfort Curve Keyboard 2000",
    "Keyboard\\Sculpt Comfort Desktop Keyboard",
    "Keyboard\\Sculpt Comfort Keyboard",
    "Keyboard\\Sculpt Ergonomic Desktop Keyboard",
    "Keyboard\\Sculpt Ergonomic Keyboard for Business",
    "Keyboard\\Sculpt Mobile Keyboard",
    "Keyboard\\SideWinder X4 Keyboard",
    "Keyboard\\Universal Foldable Keyboard",
    "Keyboard\\Universal Mobile Keyboard",
    "Keyboard\\Wedge Mobile Keyboard",
    "Keyboard\\Wired Desktop Keyboard",
    "Keyboard\\Wired Keyboard 600",
    "Keyboard\\Wireless Comfort Desktop 5050 Keyboard",
    "Keyboard\\Wireless Desktop Keyboard",
    "Keyboard\\Wireless Keyboard 2000",
    "Keyboard\\Wireless Optical Desktop 1000",
    "Mouse\\Arc Touch",
    "Mouse\\Comfort Mouse 4500",
    "Mouse\\Comfort Optical Mouse 1000",
    "Mouse\\Designer Bluetooth Desktop Mouse",
    "Mouse\\Designer Bluetooth Mouse",
    "Mouse\\Explorer Touch Mouse",
    "Mouse\\Habu Laser Gaming Mouse",
    "Mouse\\IntelliMouse Explorer 3.0 Mouse",
    "Mouse\\Ready Mouse",
    "Mouse\\Sculpt Comfort Mouse",
    "Mouse\\Sculpt Ergonomic Mouse",
    "Mouse\\Sculpt Mobile Mouse",
    "Mouse\\Sculpt Touch Mouse",
    "Mouse\\Sidewinder X3 Mouse",
    "Mouse\\SideWinder X8 Mouse",
    "Mouse\\Touch Mouse",
    "Mouse\\Wedge Touch Mouse",
    "Mouse\\Wireless Laser Mouse 5000",
    "Mouse\\Wireless Mobile Mouse 1000",
    "Mouse\\Wireless Mouse 1000",
    "MSN\\MSN",
    "MSN\\MSN 9.2 Dial-up",
    "MSN\\MSN 9.2 Dial-up Accelerator",
    "MSN\\MSN Autos",
    "MSN\\MSN Connection Center 1.0",
    "MSN\\MSN Direct",
    "MSN\\MSN Explorer (Premium/Dial-up)",
    "MSN\\MSN Games",
    "MSN\\MSN Mobile 4.0",
    "MSN\\MSN Money",
    "MSN\\MSN Music",
    "MSN\\MSN Parental Controls",
    "MSN\\MSN Partner Video Download",
    "MSN\\MSN Premier Pass Games",
    "MSN\\MSN Profiles",
    "MSN\\MSN Search",
    "MSN\\MSN Shopping",
    "MSN\\MSN SideGuide",
    "MSN\\MSN Toolbar",
    "MSN\\MSN Video Downloads",
    "MSN\\MSNBC",
    "Office Products\\21Vianet Exchange Online",
    "Office Products\\21Vianet Lync Online",
    "Office Products\\21Vianet Office 365",
    "Office Products\\21Vianet Power BI",
    "Office Products\\21Vianet Project",
    "Office Products\\21Vianet SharePoint Online",
    "Office Products\\Access",
    "Office Products\\Classroom",
    "Office Products\\Equipt",
    "Office Products\\Excel",
    "Office Products\\Gallatin Technical",
    "Office Products\\InfoPath",
    "Office Products\\Interactive Media Manager 2.0",
    "Office Products\\Lync",
    "Office Products\\Lync VDI 2013 plug-in",
    "Office Products\\Mediaroom Component Technologies",
    "Office Products\\Office 2007",
    "Office Products\\Office 2010",
    "Office Products\\Office 2013",
    "Office Products\\Office 2016",
    "Office Products\\Office 365",
    "Office Products\\Office 365 Sway",
    "Office Products\\Office Accounting",
    "Office Products\\Office App Store",
    "Office Products\\Office Communicator",
    "Office Products\\Office Diagnostics",
    "Office Products\\Office Enterprise 2007 Home Use Program",
    "Office Products\\Office for iPad",
    "Office Products\\Office for Mac 2011",
    "Office Products\\Office for Mac Home and Business 2011 Home Use Program",
    "Office Products\\Office Groove 2007",
    "Office Products\\Office Groove Enterprise Services",
    "Office Products\\Office Home and Student 2013 RT",
    "Office Products\\Office Lens",
    "Office Products\\Office Live Groove",
    "Office Products\\Office Live Meeting 2007",
    "Office Products\\Office Mobile",
    "Office Products\\Office OneNote 2007",
    "Office Products\\Office PerformancePoint 2007 Management Reporter",
    "Office Products\\Office Professional Plus 2010 Home Use Program",
    "Office Products\\Office ProPlus 2013 HUP",
    "Office Products\\Office SharePoint Server 2007",
    "Office Products\\Office Store App Development",
    "Office Products\\Office Sway",
    "Office Products\\Office Update Site",
    "Office Products\\Office XP",
    "Office Products\\OneNote",
    "Office Products\\Outlook",
    "Office Products\\Power Map for Excel",
    "Office Products\\PowerPoint",
    "Office Products\\Project",
    "Office Products\\Publisher",
    "Office Products\\SharePoint 2010 For Internet Sites Enterprise",
    "Office Products\\SharePoint Designer",
    "Office Products\\SharePoint Newsfeed",
    "Office Products\\SharePoint Online",
    "Office Products\\SharePoint Workspace 2010",
    "Office Products\\Skype for Business",
    "Office Products\\Skype Meeting Broadcast",
    "Office Products\\Skype Room Systems v2",
    "Office Products\\Teams",
    "Office Products\\Visio",
    "Office Products\\Visio Services in SharePoint Server 2010",
    "Office Products\\Word",
    "Office Products\\Word Viewer",
    "Office Products\\Yammer",
    "Online Services\\account",
    "Online Services\\Ad-Free Outlook.com Subscription",
    "Online Services\\Live Connect",
    "Online Services\\Live Search Books",
    "Online Services\\Live.com",
    "Online Services\\OneDrive",
    "Online Services\\OneDrive Billing and Accounts",
    "Online Services\\OneDrive for Business",
    "Online Services\\Outlook.com",
    "Online Services\\Outlook.com Active Views",
    "Online Services\\Partner Online services",
    "Online Services\\powerapps.com Preview",
    "Online Services\\Windows Essentials BYOA",
    "Online Services\\Windows Live",
    "Online Services\\Windows Live Gadgets",
    "Online Services\\Windows Live Messenger",
    "Online Services\\Windows Live@NET",
    "Online Services\\Windows Marketplace",
    "Other Hardware\\Enterprise Mobility Suite (EMS)",
    "Other Hardware\\HP Business Decision Appliance",
    "Other Hardware\\KIN",
    "Other Hardware\\Perceptive Pixel by Touch Devices",
    "Other Hardware\\PixelSense 2.0 Runtime",
    "Other Hardware\\PixelSense 2.0 SDK",
    "Other Hardware\\Presenter 3000",
    "Other Hardware\\Wireless Display Adapter",
    "Programs and Services\\ADR Partner Support",
    "Programs and Services\\CBO Web",
    "Programs and Services\\Channel Developer",
    "Programs and Services\\Channel Incentives Platform",
    "Programs and Services\\China OE Office 365",
    "Programs and Services\\China OSPA",
    "Programs and Services\\China OSSA Azure",
    "Programs and Services\\Commerce Platform Commercial",
    "Programs and Services\\COOP and Rebates",
    "Programs and Services\\Corporate and Major Accounts",
    "Programs and Services\\ESD Partner Support",
    "Programs and Services\\M&A Test Offering",
    "Programs and Services\\Managed Reseller",
    "Programs and Services\\My Phone",
    "Programs and Services\\Online Service Advisor",
    "Programs and Services\\Partner Center",
    "Programs and Services\\Partner Incentives Reporting",
    "Programs and Services\\Partner Sales Exchange",
    "Programs and Services\\PCSafety",
    "Programs and Services\\Raspberry Jam",
    "Programs and Services\\Romulan Ale",
    "Programs and Services\\Services Premier Maintained Applications",
    "Programs and Services\\Software Asset Management",
    "Programs and Services\\Solution Incentives",
    "Programs and Services\\Springfield",
    "Programs and Services\\Surface Incentives",
    "Programs and Services\\Surfs Up",
    "Programs and Services\\Value-Added Reseller",
    "Programs and Services\\Virus",
    "Programs and Services\\Windows 7 Application Compatibility Remediation Program",
    "Programs and Services\\Windows Phone Store",
    "Programs and Services\\Windows Store",
    "Security\\Advanced Threat Analytics",
    "Security\\Cloud App Security",
    "Security\\Enhanced Mitigation Experience Toolkit",
    "Security\\Forefront Endpoint Protection 2010",
    "Security\\Forefront Online Protection for Exchange Embedded Filtering",
    "Security\\Forefront Protection Suite",
    "Security\\Forefront Threat Management Gateway 2010",
    "Security\\Forefront Unified Access Gateway 2010",
    "Security\\Identity Manager 2016",
    "Security\\Intelligent Application Gateway 2007",
    "Security\\Secure Islands",
    "Security\\Security Essentials OEM Pre-Installation Kit",
    "Security\\System Center 2012 Endpoint Protection",
    "Security\\Windows Defender",
    "Server Management Tools\\Active Directory Rights Management Services Client 2.0",
    "Server Management Tools\\Audit and Control Management Server 2013",
    "Server Management Tools\\AVIcode, Inc.",
    "Server Management Tools\\BHOLD Suite",
    "Server Management Tools\\BizTalk Adapters for Host Systems 2.0",
    "Server Management Tools\\BizTalk WCF Adapter for SQL Server",
    "Server Management Tools\\BlueStripe",
    "Server Management Tools\\Deployment Toolkit",
    "Server Management Tools\\Engyro Product Connectors for System Center Operations Manager 2007",
    "Server Management Tools\\HPC Pack 2008",
    "Server Management Tools\\HPC Pack 2008 R2",
    "Server Management Tools\\HPC Pack 2012",
    "Server Management Tools\\HPC Pack 2012 R2",
    "Server Management Tools\\Internet Storage Name Service (iSNS) Server 3.0",
    "Server Management Tools\\iSCSI Software Target 3.3",
    "Server Management Tools\\Lync Server 2010 Capacity Planning Tool",
    "Server Management Tools\\Lync Server 2010 Group Chat Software Development Kit",
    "Server Management Tools\\Lync Server 2010, Group Chat",
    "Server Management Tools\\Lync Server 2013 Best Practices Analyzer",
    "Server Management Tools\\Lync Server 2013 Debugging Tools",
    "Server Management Tools\\Lync Server 2013 Monitoring Management Pack",
    "Server Management Tools\\Lync Server 2013 Stress and Performance Tool",
    "Server Management Tools\\Lync Server 2013 Watcher Node",
    "Server Management Tools\\Server management tools",
    "Server Management Tools\\Service Bus for Windows Server",
    "Server Management Tools\\Service Fabric stand-alone package for Windows Server",
    "Server Management Tools\\Software Inventory Logging Aggregator 1.0 for Windows Server",
    "Server Management Tools\\SQL Server Migration Assistant",
    "Server Management Tools\\System Center Advisor",
    "Server Management Tools\\System Center App Controller",
    "Server Management Tools\\System Center Capacity Planner",
    "Server Management Tools\\System Center Configuration Manager",
    "Server Management Tools\\System Center Data Protection Manager",
    "Server Management Tools\\System Center Desktop Error Monitoring",
    "Server Management Tools\\System Center Endpoint Protection",
    "Server Management Tools\\System Center Essentials",
    "Server Management Tools\\System Center Mobile Device Manager",
    "Server Management Tools\\System Center Operations Manager",
    "Server Management Tools\\System Center Orchestrator",
    "Server Management Tools\\System Center Service Manager",
    "Server Management Tools\\System Center Virtual Machine Manager",
    "Server Management Tools\\Unified Communications Managed API v3.0 Software Development Kit",
    "Server Management Tools\\Workflow Manager 1.0",
    "Server Management Tools\\Workflow Manager Client 1.0",
    "Servers\\BizTalk Server",
    "Servers\\Commerce Server 2009",
    "Servers\\DATAllegro Archive",
    "Servers\\Dell Quickstart Data Warehouse Appliance",
    "Servers\\Duet for Office and SAP 1.5",
    "Servers\\Exchange Server",
    "Servers\\FAST AdMomentum 3",
    "Servers\\FAST Application Management Services",
    "Servers\\FAST ESP",
    "Servers\\FAST Featured Content 1.3",
    "Servers\\FAST ImPulse",
    "Servers\\FAST Recommendations",
    "Servers\\FAST Search Server 2010 for Internal Applications",
    "Servers\\FAST Unity 2.5",
    "Servers\\Forefront Identity Manager 2010",
    "Servers\\Groove Server 2010",
    "Servers\\HDInsight Server",
    "Servers\\Host Integration Server",
    "Servers\\HP Database Consolidation Solution for SQL Server",
    "Servers\\HP Enterprise Data Warehouse For",
    "Servers\\Hyper-V Server",
    "Servers\\Hyper-V Server 2008",
    "Servers\\Internet Information Services",
    "Servers\\Lync 2010 Attendant",
    "Servers\\Lync 2010 Attendee",
    "Servers\\Lync 2010 Group Chat",
    "Servers\\Lync 2010 Software Development Kit",
    "Servers\\Lync Phone Edition",
    "Servers\\Lync Server",
    "Servers\\Mohoro",
    "Servers\\Office Communications Server 2007",
    "Servers\\Office Communicator Mobile (2007 Release)",
    "Servers\\Office Forms Server 2007",
    "Servers\\Office Groove Server 2007",
    "Servers\\Office Online Server",
    "Servers\\Office PerformancePoint Server 2007",
    "Servers\\Office Web Apps Server 2013",
    "Servers\\Opalis Integration Server",
    "Servers\\ProClarity Analytics Server 6.3",
    "Servers\\ProClarity Dashboard Server 6.3",
    "Servers\\ProClarity Desktop Professional 6.3",
    "Servers\\Project Portfolio Server 2007",
    "Servers\\Project Server",
    "Servers\\Search Server",
    "Servers\\SharePoint Foundation",
    "Servers\\SharePoint Server",
    "Servers\\SQL Server 2008",
    "Servers\\SQL Server 2008 R2",
    "Servers\\SQL Server 2008 R2 PowerPivot for Excel 2010",
    "Servers\\SQL Server 2012",
    "Servers\\SQL Server 2012 Enterprise Core",
    "Servers\\SQL Server 2012 Parallel Data Warehouse (APS)",
    "Servers\\SQL Server 2014",
    "Servers\\SQL Server 2016",
    "Servers\\SQL Server Compact",
    "Servers\\SQL Server Early Adopter Program",
    "Servers\\SQL Server Management Studio",
    "Servers\\Windows Essential Business Server 2008",
    "Servers\\Windows HPC Server 2008",
    "Servers\\Windows Live OneCare for Server",
    "Servers\\Windows MultiPoint Server",
    "Servers\\Windows Remote Management",
    "Servers\\Windows Server 2008",
    "Servers\\Windows Server 2008 for Windows",
    "Servers\\Windows Server 2012",
    "Servers\\Windows Server 2012 R2",
    "Servers\\Windows Server 2016",
    "Servers\\Windows Server AppFabric",
    "Servers\\Windows Server Developer Preview",
    "Servers\\Windows Server Technical Preview",
    "Servers\\Windows Server Update Services",
    "Servers\\Windows SharePoint Services 3.0",
    "Servers\\Windows Small Business Server",
    "Servers\\Windows SMTP Server",
    "Servers\\Windows Storage Server 2008",
    "Servers\\Windows Storage Server 2012",
    "Servers\\Windows Workflow Foundation",
    "Skype\\Skype",
    "Surface\\Surface 2",
    "Surface\\Surface 3",
    "Surface\\Surface 65W Power Supply",
    "Surface\\Surface Book",
    "Surface\\Surface Dock",
    "Surface\\Surface Hub",
    "Surface\\Surface Pro",
    "Surface\\Surface RT",
    "Surface\\Surface Studio",
    "Windows\\Windows 10",
    "Windows\\Windows 10 Mobile",
    "Windows\\Windows 7",
    "Windows\\Windows 8",
    "Windows\\Windows 8.1",
    "Windows\\Windows Developer Preview",
    "Windows\\Windows Embedded",
    "Windows\\Windows Embedded CE 6.0",
    "Windows\\Windows Embedded Industry",
    "Windows\\Windows Embedded POSReady",
    "Windows\\Windows Media Center",
    "Windows\\Windows Phone 8 for Business",
    "Windows\\Windows Phone 8.1",
    "Windows\\Windows RT",
    "Windows\\Windows XP",
    "Windows Add-On Programs\\Advanced Group Policy Management",
    "Windows Add-On Programs\\Application Virtualization",
    "Windows Add-On Programs\\Baseline Security Analyzer",
    "Windows Add-On Programs\\BitLocker Administration and Monitoring",
    "Windows Add-On Programs\\Desktop Optimization Pack",
    "Windows Add-On Programs\\Diagnostics and Recovery Toolset",
    "Windows Add-On Programs\\Enterprise Desktop Virtualization",
    "Windows Add-On Programs\\Genuine Windows",
    "Windows Add-On Programs\\Microsoft Update",
    "Windows Add-On Programs\\Mobile Ads",
    "Windows Add-On Programs\\Outlook Social Connector Beta",
    "Windows Add-On Programs\\Ultra Low Cost PC OEM Preinstall Kit",
    "Windows Add-On Programs\\Virtual PC 2007",
    "Windows Add-On Programs\\Windows Automated Installation Kit for Windows 7",
    "Windows Add-On Programs\\Windows Azure Pack (on Windows",
    "Windows Add-On Programs\\Windows Embedded Device Manager",
    "Windows Add-On Programs\\Windows Essentials OEM Preinstall Kit",
    "Windows Add-On Programs\\Windows Installer 4.5",
    "Windows Add-On Programs\\Windows Live Mobile Browse",
    "Windows Add-On Programs\\Windows Live OneCare",
    "Windows Add-On Programs\\Windows Preinstallation Environment",
    "Windows Add-On Programs\\Windows Telemetry Specifications",
    "Windows Add-On Programs\\Windows Thin PC",
    "Windows Add-On Programs\\Windows Update",
    "Windows Add-On Programs\\Windows Virtual PC",
    "Xbox and PC Games\\Games for Windows - LIVE",
    "Xbox and PC Games\\Kinect for Xbox 360",
    "Xbox and PC Games\\Xbox",
    "Xbox and PC Games\\Xbox Live",
    "Zune\\Zune 120GB Digital Media Player",
    "Zune\\Zune 30GB Digital Media Player",
    "Zune\\Zune 4GB Digital Media Player",
    "Zune\\Zune 80GB Digital Media Player",
    "Zune\\Zune 8GB Digital Media Player",
    "Zune\\Zune Audio Cable",
    "Zune\\Zune Cable Pack",
    "Zune\\Zune Car",
    "Zune\\Zune Dock",
    "Zune\\Zune Dual Connect Remote",
    "Zune\\Zune FM Transmitter",
    "Zune\\Zune HD 16GB",
    "Zune\\Zune HD 64GB",
    "Zune\\Zune Leather Case",
    "Zune\\Zune Live",
    "Zune\\Zune Premium Earphones",
    "Zune\\Zune software",
    "Zune\\Zune Standard Earbuds",
    "Zune\\Zune Sync Cable",
    "Zune\\Zune Travel Pack"
  ];
}
